// Gecici ornek veri — Channels modulu (Portal / Email / Widget / WhatsApp / Telegram).
// Her kanal bir entegrasyon: baglanti durumu + ayar satirlari. Backend gelince
// getChannels() ile degistirilir; simdilik mock.

export interface ChannelSetting {
    label: string;
    value: string;
}

export interface Channel {
    // URL slug'i (path eslemesi icin): portal | email | widget | whatsapp | telegram
    slug: string;
    name: string;
    icon: string;        // dx-icon adi
    connected: boolean;
    description: string;
    openTickets: number;
    settings: ChannelSetting[];
}

export const MOCK_CHANNELS: Record<string, Channel> = {
    portal: {
        slug: "portal",
        name: "Müşteri Portalı",
        icon: "dx-icon-globe",
        connected: true,
        description: "Müşterilerin giriş yaparak talep açtığı self-servis portal.",
        openTickets: 42,
        settings: [
            { label: "Portal URL", value: "https://destek.mobi.de" },
            { label: "Kayıt", value: "Yalnızca davetli" },
            { label: "Dil", value: "DE, EN, TR" },
            { label: "Marka Teması", value: "mobi Light" },
        ],
    },
    email: {
        slug: "email",
        name: "E-posta",
        icon: "dx-icon-email",
        connected: true,
        description: "Gelen e-postalardan otomatik ticket oluşturma.",
        openTickets: 87,
        settings: [
            { label: "Gelen Adres", value: "support@mobi.de" },
            { label: "Protokol", value: "IMAP / SMTP" },
            { label: "Sunucu", value: "mail.mobi.de:993" },
            { label: "Otomatik Yanıt", value: "Açık" },
        ],
    },
    widget: {
        slug: "widget",
        name: "Web Widget",
        icon: "dx-icon-comment",
        connected: true,
        description: "Web sitesine gömülü canlı destek widget'ı.",
        openTickets: 15,
        settings: [
            { label: "Widget ID", value: "wdg_8f3a21" },
            { label: "Konum", value: "Sağ alt" },
            { label: "Çalışma Saati", value: "09:00 – 18:00" },
            { label: "Karşılama Mesajı", value: "Size nasıl yardımcı olabiliriz?" },
        ],
    },
    whatsapp: {
        slug: "whatsapp",
        name: "WhatsApp",
        icon: "dx-icon-tel",
        connected: false,
        description: "WhatsApp Business API üzerinden mesajlaşma.",
        openTickets: 0,
        settings: [
            { label: "Telefon No", value: "—" },
            { label: "API Sağlayıcı", value: "Meta Cloud API" },
            { label: "Durum", value: "Bağlantı bekleniyor" },
        ],
    },
    telegram: {
        slug: "telegram",
        name: "Telegram",
        icon: "dx-icon-message",
        connected: false,
        description: "Telegram bot üzerinden destek talebi alma.",
        openTickets: 0,
        settings: [
            { label: "Bot Kullanıcı Adı", value: "—" },
            { label: "Bot Token", value: "—" },
            { label: "Durum", value: "Bağlantı bekleniyor" },
        ],
    },
};

export const CHANNEL_ORDER = ["portal", "email", "widget", "whatsapp", "telegram"];
